import { useMemo } from 'react'
import { ClickNavigationSection } from '../../../../../components/NavigationWithSideBar/ClickNavigation'
import { IntegrationServiceId } from '../../../../../common/integrations'
import { useAccount } from '../../../../../common/useAccount'
import { getEffectiveAccountIntegrationConfig, PlanningAccountIntegrationConfig } from '../../../../../models/Account'
import { EMoneyAdminInstanceSettings } from './EMoneyAdminInstanceSettings'

export const useEMoneyAdminSettings = (): ClickNavigationSection[] => {
  const { account } = useAccount({ refetchOnMountOrArgChange: true })

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const accountConfig = useMemo(
    () => getEffectiveAccountIntegrationConfig(account, IntegrationServiceId.E_MONEY),
    [account],
  ) as PlanningAccountIntegrationConfig | null

  const adminEnabled = false

  return useMemo<ClickNavigationSection[]>(() => {
    if (!adminEnabled) {
      return []
    }
    return [{ id: 'instanceSettings', label: 'Instance Setting', content: () => <EMoneyAdminInstanceSettings /> }]
  }, [adminEnabled])
}
